
import { defineComponent } from "vue";
import AppSlide from "./app-slide.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/apps/bty-seo-pc/stores/app";

export default defineComponent({
  props: {
    btyUrl: {
      type: String,
      required: true,
    },
  },
  components: {
    AppSlide,
  },
  computed: {
    style() {
      const { scrollTop } = this;
      const start = 1441;
      const min = 0.92;
      let opacity = 0.8;
      if (scrollTop < start) {
        return { transform: `scale(${min})`, opacity };
      }
      const top = scrollTop - start;
      const delta = 0.00025;
      const scale = Math.min(top * delta + min, 1);
      const opacityDelta = top * 0.001;
      const o = Math.min(opacity + opacityDelta, 1);
      return {
        transform: `scale(${scale})`,
        opacity: o,
      };
    },
    imageStyle() {
      const { scrollTop } = this;
      const start = 1950;
      if (scrollTop < start) {
        return { transform: "translateY(0px)" };
      }
      const top = scrollTop - start;
      const delta = 0.9;
      const y = Math.min(top * delta, 280);
      return { transform: `translateY(${y}px)` };
    },
    ...mapState(useAppStore, ["scrollTop"]),
  },
  render() {
    return (
      <AppSlide>
        <div class="slide3__box container" style={this.style}>
          <div>
            <div class="slide3__title">Brand Ambassador</div>
            <h2>独家品牌大使</h2>
            <div class="slide3__name">法比奥·卡纳瓦罗</div>
            <ul>
              <li>卡纳瓦罗被认为是有史以来最出色的后卫之一，</li>
              <li>他也是少数获得了欧洲金球奖的后卫</li>
              <li>和唯一一名获得了世界足球先生的后卫。</li>
            </ul>
            <div class="slide3__name last">保罗·皮尔斯</div>
            <ul>
              <li>NBA总冠军（2008）</li>
              <li>NBA总决赛MVP（2008）</li>
              <li>4次入选NBA最佳阵容</li>
              <li>10次入选NBA全明星赛</li>
              <li>NBA最佳新秀阵容第一队</li>
              <li>NBA三分球大赛冠军</li>
              <li>NBA常规赛总得分第一：2002 (2144分)</li>
              <li>NBA常规赛罚球得分次数：2003 (604个)</li>
            </ul>
            <a class="btn btn-primary" href={this.btyUrl} target="_blank">
              立即体验
              <img src={require("./arrow-right.svg")} alt="" loading="lazy" />
            </a>
          </div>
          <img
            class="slide3__image-two-people"
            src={require("./two-people.png")}
            alt=""
            loading="lazy"
            style={this.imageStyle}
          />
        </div>
      </AppSlide>
    );
  },
});
